import { OutlineButtonContainer } from "@pages/casino/assets/styles/mixins.js";
import { Card } from "antd";
import React from "react";
import { Translate } from "react-localize-redux";

import DefaultCasinoIcon from "@pages/casino/assets/backgrounds/default-casino-icon.png";
import { CloseIcon, DiceIcon, PlayNowIcon, TryAgainIcon } from "@pages/casino/assets/icons";
import { Modal } from "@pages/casino/components";

import {
	CardContentWrapper,
	CardTitle,
	CardWrapper,
	ContentWrapper,
	GameAffiliateName,
	GameName,
	ImageContentWrapper,
	ImageWrapper,
	PlayNowButton,
	TryAgainButton,
} from "./elements.js";
import useController from "./useController.js";

const DefaultIFeelLuckyModal = ({ labelKey = "casino.ifeellucky" }) => {
	const {
		state: { isToggled, randomGame, casinoGames },
		handlers: { handleToggleChange, handlePlayButtonClick, handleGameSelect },
	} = useController();

	return (
		<Translate>
			{({ translate }) => (
				<>
					<OutlineButtonContainer
						data-testid="button-casino-filter-i-feel-lucky"
						onClick={handleToggleChange}>
						<DiceIcon />
						<span>{translate(labelKey)}</span>
					</OutlineButtonContainer>
					<Modal
						position={"centered"}
						open={isToggled}
						onClose={handleToggleChange}>
						{casinoGames.length == 0 ? null : (
							<ContentWrapper>
								<CardWrapper>
									<Card>
										<CardTitle data-testid="text-lucky-modal-title">
											{translate("YOU_ARE_LUCKY")}
										</CardTitle>
										<CardContentWrapper>
											<ImageWrapper>
												<img
													className="big-image"
													data-testid="image-lucky-modal-game"
													src={`${
														randomGame?.icon_custom_url
															? randomGame?.icon_custom_url
															: randomGame?.game_icon_url
																? randomGame?.game_icon_url
																: DefaultCasinoIcon
													}`}
												/>
											</ImageWrapper>
											<ImageContentWrapper>
												<GameAffiliateName>
													{randomGame?.affiliate}
												</GameAffiliateName>
												<GameName data-testid="text-lucky-modal-game-name">
													{randomGame?.remote_name}
												</GameName>
												<PlayNowButton
													data-testid="button-lucky-modal-play"
													onClick={handlePlayButtonClick}>
													<PlayNowIcon />
													{translate("PLAY_NOW")}
												</PlayNowButton>
												<TryAgainButton
													data-testid="button-lucky-modal-try-again"
													onClick={handleGameSelect}>
													<TryAgainIcon />
													{translate("TRY_AGAIN")}
												</TryAgainButton>
											</ImageContentWrapper>
										</CardContentWrapper>
									</Card>
								</CardWrapper>
								<CloseIcon
									className="modal-close-icon"
									data-testid="button-lucky-modal-close"
									onClick={handleToggleChange}
								/>
							</ContentWrapper>
						)}
					</Modal>
				</>
			)}
		</Translate>
	);
};

export default DefaultIFeelLuckyModal;
